import {FooterSection, Header} from './sections';
import "./sections/style.css";
import ReactGA from "react-ga4";
import {useEffect} from 'react';
import Maintenance from "../Error/maintenance";
import SEO from '../../components/common/SEO';
import {breadcrumbSchema} from '../../utils/structuredData';


const Home = () => {
    useEffect(()=>{
        if(process.env.REACT_APP_ENV === "production") {
            ReactGA.initialize("G-ZB9N7T58NE");
            ReactGA.send({ hitType: "pageview", page: "/", title: "Licensing Page" });
        }
    },[])
    
    const breadcrumbs = breadcrumbSchema([
        { name: 'Home', url: '/' },
        { name: 'Licensing', url: '/licensing' }
    ]);

    return (
        <div className="w-full homePageContainer relative">
            <SEO
                title="Licensing Terms - CadencePro.ai | Software License Agreement"
                description="Review CadencePro's licensing terms and software usage agreements. Understand your rights and responsibilities when using our AI-powered project management platform."
                canonical="/licensing"
                keywords="cadencepro licensing, software license agreement, terms of use, software usage rights"
                structuredData={breadcrumbs}
            />
            <Header />
            <Maintenance />
            <FooterSection />
            <footer className="px-10 bg-gray-900">
                <img className="w-full" src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/cadencepro.ai.png" alt="" />
            </footer>
        </div>
    )
};

export default Home;
